import { useState } from 'react';

/**
 * Hook to manage page state for Users page
 * @returns {Object} Page state and handlers
 */
export const useUsersPageState = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [users, setUsers] = useState([]);
  const [totalUsers, setTotalUsers] = useState(0);
  const [loading, setLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [exportDialogOpen, setExportDialogOpen] = useState(false);
  const [importDialogOpen, setImportDialogOpen] = useState(false);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleOpenExportDialog = () => {
    setExportDialogOpen(true);
  };

  const handleCloseExportDialog = () => {
    setExportDialogOpen(false);
  };

  const handleOpenImportDialog = () => {
    setImportDialogOpen(true);
  };

  const handleCloseImportDialog = () => {
    setImportDialogOpen(false);
  };

  return {
    // State
    page,
    rowsPerPage,
    users,
    totalUsers,
    loading,
    dialogOpen,
    exportDialogOpen,
    importDialogOpen,
    // Setters
    setPage,
    setRowsPerPage,
    setUsers,
    setTotalUsers,
    setLoading,
    setDialogOpen,
    setExportDialogOpen,
    setImportDialogOpen,
    // Handlers
    handleChangePage,
    handleChangeRowsPerPage,
    handleOpenDialog,
    handleCloseDialog,
    handleOpenExportDialog,
    handleCloseExportDialog,
    handleOpenImportDialog,
    handleCloseImportDialog,
  };
};

